<template>
  <div class="query-log">
    <el-button-group class="chart-type-switcher">
      <el-button size="mini" :type="type==='chart' ? 'primary': 'default'" @click="type='chart'">图表</el-button>
      <el-button size="mini" :type="type==='table' ? 'primary': 'default'" @click="type='table'">详细</el-button>
    </el-button-group>
    <div v-if="type==='chart'" class="line-chart-container">
      <day-query-line-chart chart-type="vin" :company-id="companyId"></day-query-line-chart>
    </div>
    <div v-else>
      <data-table
        class="compnay-query-table"
        :columns="schema"
        :list="datas"
        :is-loading="isLoading"
      >
      </data-table>
      <el-pagination
        background
        layout="prev, pager, next"
        :pager-count="5"
        :current-page.sync="pagination.pageIndex"
        :total="pagination.totalCount"
        :page-size="pagination.pageSize"
        @current-change="handlePageIndexChange"
      />
    </div>
  </div>
</template>
<script>
import DayQueryLineChart from './DayQueryLineChart.vue'
import DataTable from '@/components/DataTable'
import moment from 'moment'
import { ListVinQueryDetail } from '../services'
export default {
  name: 'VinQueryLog',
  components: { DayQueryLineChart, DataTable },
  props: {
    companyId: {
      type: Number,
      default () {
        return 0
      }
    }
  },
  data () {
    return {
      type: 'table',
      schema: [
        {
          name: '时间',
          code: 'createTime',
          renderFunc (val) {
            return moment(val).format('YYYY-MM-DD HH:mm:ss')
          }
        },
        {
          name: '品牌',
          code: 'brandCode'
        },
        {
          name: 'VIN',
          code: 'vin',
          renderFunc (val) {
            return val.toUpperCase()
          }
        },
        {
          name: '是否计费',
          code: 'cost',
          renderFunc (val) {
            return val === 1 ? '是' : '否'
          }
        }
      ],
      datas: [],
      isLoading: false,
      loaded: false,
      pagination: {
        totalCount: 0,
        pageSize: 30,
        pageIndex: 1
      }
    }
  },
  watch: {
    type () {
      if (this.type === 'table' && this.loaded === false) {
        this.fetchData()
      }
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      const { pageSize, pageIndex } = this.pagination
      this.isLoading = true
      ListVinQueryDetail({ pageSize, pageIndex, companyId: this.companyId }).then((res) => {
        this.datas = res.items
        this.pagination = res.pagination
        this.loaded = true
        this.isLoading = false
      })
    },
    handlePageIndexChange (page) {
      this.pagination.pageIndex = +page
      this.fetchData()
    },
    handlePageSizeChange (size) {
      if (this.pagination.total > size * (+this.pagination.pageIndex)) {
        this.pagination.pageSize = size
      } else {
        this.pagination.pageIndex = 1
        this.pagination.pageSize = size
      }
      this.fetchData()
    }
  }
}
</script>
